import React from 'react';

import { Typography } from '@mui/material';

import type { PaymentMethodItemProps } from '../types';

type BankCardPaymentMethodItemProps = Pick<PaymentMethodItemProps, 'paymentMethod'>;

export const BankCardPaymentMethodItem: React.FC<BankCardPaymentMethodItemProps> = ({
  paymentMethod,
}) => {
  return (
    <Typography variant="body2" color="text.secondary" fontWeight="bold" textTransform="uppercase">
      {paymentMethod.card?.brand} **** {paymentMethod.card?.last4}
    </Typography>
  );
};
